import { render, staticRenderFns } from "./TableImageItem.vue?vue&type=template&id=20a5b6f0&scoped=true"
import script from "./TableImageItem.vue?vue&type=script&lang=js"
export * from "./TableImageItem.vue?vue&type=script&lang=js"
import style0 from "./TableImageItem.vue?vue&type=style&index=0&id=20a5b6f0&scoped=true&lang=css"
import style1 from "./TableImageItem.vue?vue&type=style&index=1&id=20a5b6f0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5b6f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a5b6f0')) {
      api.createRecord('20a5b6f0', component.options)
    } else {
      api.reload('20a5b6f0', component.options)
    }
    module.hot.accept("./TableImageItem.vue?vue&type=template&id=20a5b6f0&scoped=true", function () {
      api.rerender('20a5b6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableImageItem.vue"
export default component.exports